import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgLink = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.25 9.65a5.953 5.953 0 0 1-1.75 4.047L20.7 17.5a5.935 5.935 0 0 1-4.226 1.75h-.005a5.976 5.976 0 0 1-5.969-6.143.875.875 0 1 1 1.75.05 4.224 4.224 0 0 0 7.207 3.106l3.8-3.8a4.225 4.225 0 0 0-5.975-5.976L16.08 7.69a.875.875 0 0 1-1.237-1.237l1.203-1.203a5.977 5.977 0 0 1 9.782 2.02 6 6 0 0 1 .423 2.38ZM11.922 20.306l-1.203 1.204a4.201 4.201 0 0 1-2.997 1.24 4.225 4.225 0 0 1-2.985-7.212l3.794-3.801a4.225 4.225 0 0 1 7.219 3.106.875.875 0 0 0 1.75.05 6.001 6.001 0 0 0-1.75-4.393 5.977 5.977 0 0 0-8.451 0L3.5 14.3a5.974 5.974 0 0 0 8.444 8.45l1.203-1.203a.875.875 0 0 0-1.225-1.24Z" />
  </svg>
);
export default SvgLink;
